/* eslint-disable no-mixed-spaces-and-tabs */
import { Stack, Typography, Grid, Box } from '@mui/material';
import React from 'react';

export const PageHeader = ({ title, icon, isBeta = false, headerElement, compact = false }) => {
	return (
		<Grid
			container
			justifyContent='space-between'
			alignItems='center'
			sx={{ px: compact ? 0 : 3, py: compact ? 0 : '1em' }}
		>
			<Grid>
				<Stack direction='row' alignItems='center' width='100%' spacing={1}>
					{icon && (
						<Box
							sx={{
								display: 'inline-flex',
								alignItems: 'center',
								minHeight: compact ? '32px' : '40px',
								lineHeight: 0,
								'& > .MuiSvgIcon-root, & > svg': {
									width: compact ? 32 : 40,
									height: compact ? 32 : 40,
								},
							}}
						>
							{icon}
						</Box>
					)}
					<Stack direction='row' alignItems='center' spacing={1}>
						<Typography
							variant='h4'
							sx={{
								fontWeight: 'bold',
								...(compact && { fontSize: '20px' }),
							}}
						>
							{title}
						</Typography>
						{isBeta && (
							<Box
								sx={{
									backgroundColor: '#34495E',
									color: 'white',
									borderRadius: '4px',
									padding: '2px 10px',
									fontSize: '0.7em',
									whiteSpace: 'nowrap',
								}}
							>
								BETA
							</Box>
						)}
					</Stack>
				</Stack>
			</Grid>

			<Grid>
				<Stack direction='row' alignItems='center' spacing={2}>
					{headerElement}
				</Stack>
			</Grid>
		</Grid>
	);
};

PageHeader.displayName = 'PageHeader';
